
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parlors/region/[code]",
      function () {
        return require("private-next-pages/parlors/region/[code]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parlors/region/[code]"])
      });
    }
  